<template><!-- svgo-optimised -->
<svg class="icon icon__arrow icon__arrow--left" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg"><path d="m9.68 12.482 6.284-6.16-.84-.822L8 12.482l7.16 7.018.84-.823-6.32-6.194Z" fill="#1A1A1E"/></svg>
</template>